import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Home from '../views/208Page.vue'
// import Home from '../views/Pine-Grove.vue'
// import Home from '../views/PDF-Page.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HOME',
    component: Home
  },
  {
    path: '/location',
    name: 'LOCATION',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LOCATION.vue')
  },
  {
    path: '/FACILITIES',
    name: 'FACILITIES',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FACILITIES.vue')
  },
  {
    path: '/INTERIOR',
    name: 'INTERIOR',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/INTERIOR.vue')
  },
  {
    path: '/GALLERY',
    name: 'GALLERY',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/GALLERY.vue')
  },
  {
    path: '/BROCHURE',
    name: 'BROCHURE',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/BROCHURE.vue')
  },
  {
    path: '/CONTACT',
    name: 'CONTACT',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CONTACT.vue')
  },
  {
    path: '/DEVELOPERS',
    name: 'DEVELOPERS',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/DEVELOPERS.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
